export const geoRecordId = (row: any): string => {
  const raw = row?.id ?? row?._id;
  if (raw && typeof raw === "object") {
    return String(raw.$oid || raw.oid || raw.id || "");
  }
  return raw ? String(raw) : "";
};

export const parseGeoPath = (
  pathname: string,
  root: "gi-registry" | "looms" | "certifications" | "orders"
): {
  id?: string;
  isNew: boolean;
  isEdit: boolean;
  isView: boolean;
  isAuthorisedUser: boolean;
} => {
  const parts = String(pathname || "")
    .split("/")
    .filter(Boolean);
  const idx = parts.indexOf(root);
  if (idx < 0) {
    return { isNew: true, isEdit: true, isView: false, isAuthorisedUser: false };
  }
  const second = parts[idx + 1];
  if (!second || second === "new") {
    return { isNew: true, isEdit: true, isView: false, isAuthorisedUser: false };
  }
  const isAuthorisedUser = parts[idx + 2] === "authorised-user";
  const isEdit = parts[idx + 2] === "edit";
  return {
    id: second,
    isNew: false,
    isEdit,
    isView: !isEdit && !isAuthorisedUser,
    isAuthorisedUser,
  };
};

export const unwrapGeoPayload = (res: any): any => {
  const data = res?.data;
  if (data && typeof data === "object" && !Array.isArray(data)) {
    if (data.id || data._id || data.name || data.loomCode || data.docs) {
      return data;
    }
    if (data.data && typeof data.data === "object") {
      return data.data;
    }
  }
  return data;
};
